type PathVariables = {
  [key: string]: string
}

export const getPathVariables = (variables: Array<string>): PathVariables => {
  const pathArray = window.location.pathname.split('/')
  const variableObj: PathVariables = {}

  try {
    variables.forEach((variable) => {
      const variableIndex = pathArray.indexOf(variable)

      if (variableIndex >= 0) {
        variableObj[variable] = pathArray[variableIndex + 1]
      } else {
        throw new Error('Variable is not present in path')
      }
    })
  } catch (e) {
    variableObj.error = e
    console.error(e)
  }

  return variableObj
}
